// services/productService.js

import apiClient from '../services/api';

// Get all products
const getAllProducts = async () => {
  try {
    const response = await apiClient.get('/products/');  // Add trailing slash here
    return response;
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};

// Get a specific product
const getProduct = async (productId) => {
  try {
    const response = await apiClient.get(`/products/${productId}/`);  // Add trailing slash here
    return response;
  } catch (error) {
    console.error(`Error fetching product ${productId}:`, error);
    throw error;
  }
};

// Create a new product
const createProduct = async (productData) => {
  try {
    const response = await apiClient.post('/products/', productData);  // Add trailing slash here
    return response;
  } catch (error) {
    console.error('Error creating product:', error);
    throw error;
  }
};

// Update an existing product
const updateProduct = async (productId, productData) => {
  try {
    const response = await apiClient.put(`/products/${productId}/`, productData);  // Add trailing slash here
    return response;
  } catch (error) {
    console.error(`Error updating product ${productId}:`, error);
    throw error;
  }
};

// Delete a product
const deleteProduct = async (productId) => {
  try {
    const response = await apiClient.delete(`/products/${productId}/`);  // Add trailing slash here
    return response;
  } catch (error) {
    console.error(`Error deleting product ${productId}:`, error);
    throw error;
  }
};

export default {
  getAllProducts,
  getProduct,
  createProduct,
  updateProduct,
  deleteProduct
};
